import { demoBadgeClassName } from '@/features/session-tutorial/sessionTutorial.styles';
import type { SessionTutorialDemoBadgeProps } from '@/features/session-tutorial/sessionTutorial.types';
import { sessionTutorialNav } from '@/features/session-tutorial/sessionTutorialContent';
import { SESSION_TUTORIAL_UI_ATTRIBUTE } from '@/features/session-tutorial/useInertOutside';
import { Badge, Button, Stack } from '@careflux/primitives';
import { createPortal } from 'react-dom';

/** Marks the sample as fictional while it is on screen, and can always end the tour (e.g. mid-generation). */
export const SessionTutorialDemoBadge = ({ onSkip }: SessionTutorialDemoBadgeProps) =>
  createPortal(
    <div className={demoBadgeClassName} {...{ [SESSION_TUTORIAL_UI_ATTRIBUTE]: '' }}>
      <Stack direction="horizontal" gap="xs" align="center">
        <output>
          <Badge variant="warning">{sessionTutorialNav.demoBadge}</Badge>
        </output>
        <Button variant="outline" size="sm" onClick={onSkip}>
          {sessionTutorialNav.skipTour}
        </Button>
      </Stack>
    </div>,
    document.body
  );
